import styled from 'styled-components';

export const VideoStyle = styled.video`
  display: block;
  margin: 0 auto;
  box-shadow: 0 16px 26px -5px rgba(50,50,93,.1), 0 8px 16px -8px rgba(0,0,0,.2);
  border-radius: 4px;
  width: 100%;
  max-width: 832px;
  height: auto;
  outline: none;
`;

export const VideoContain = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  max-width: 100%;
  overflow: hidden;

  iframe, video, > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    outline: none;
  }
`

export const Poster = styled.div`
  display: block;
  position: relative;
  border-radius: 4px;
  box-shadow: 0 16px 26px -5px rgba(50,50,93,.1), 0 8px 16px -8px rgba(0,0,0,.2);
  margin: 0 auto;
  max-width: 832px;
  cursor: pointer;
  transition: 150ms;
  transition-timing-function: ease-in-out;

  > img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  &:hover {
    svg {
      opacity: .8;
    }
  }

  img {
    display: block;
    border-radius: 4px;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -40px 0 0 -40px;
  }
`;
